var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPropsPlaceholderSmall = function SvgIconPropsPlaceholderSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 4.333H1.667c-.734 0-1.334.6-1.334 1.334v6.667c0 .733.6 1.333 1.334 1.333h6.666c.734 0 1.334-.6 1.334-1.333V5.667c0-.733-.6-1.333-1.334-1.333Zm-2.666 8.334H4.333v-1h1.334v1Zm0-1.667H4.333c0-1-1.666-2-1.666-3.333A2.336 2.336 0 0 1 5 5.334a2.336 2.336 0 0 1 2.333 2.333C7.333 9 5.667 10 5.667 11ZM9 3.333H1c0-.553.447-1 1-1h6c.553 0 1 .447 1 1Zm-.667-2H1.667c0-.553.446-1 1-1h4.666c.554 0 1 .447 1 1Z",
    fill: "#C6C8CC"
  })));
};
export default SvgIconPropsPlaceholderSmall;